import { useEffect, useState } from "react";
import { usePageMeta } from "@/lib/seo";
import { apiClient } from "@/lib/api";
import Hero from "@/components/home/Hero";
import TrustBadgeBar from "@/components/layout/TrustBadgeBar";
import CategoryGrid from "@/components/home/CategoryGrid";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import WhyChooseUs from "@/components/home/WhyChooseUs";
import LabTestingSection from "@/components/home/LabTestingSection";
import ResearchTimeline from "@/components/home/ResearchTimeline";
import AboutPreview from "@/components/home/AboutPreview";
import FAQPreview from "@/components/home/FAQPreview";
import Newsletter from "@/components/home/Newsletter";
import StatsSection from "@/components/home/StatsSection";

export default function Home() {
  usePageMeta(null, null, "/");
  const [categories, setCategories] = useState([]);
  const [featured, setFeatured] = useState([]);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    apiClient.get("/categories").then((res) => setCategories(res.data)).catch(() => {});
    apiClient.get("/products?featured=true&page_size=8").then((res) => setFeatured(res.data.items)).catch(() => {});
    apiClient.get("/faqs").then((res) => setFaqs(res.data)).catch(() => {});
  }, []);

  const categoryMap = Object.fromEntries(categories.map((c) => [c.id, c.slug]));

  return (
    <div data-testid="home-page">
      <Hero />
      <TrustBadgeBar />
      {categories.length > 0 && <CategoryGrid categories={categories} />}
      {featured.length > 0 && <FeaturedProducts products={featured} categoryMap={categoryMap} />}
      <WhyChooseUs />
      <LabTestingSection />
      <StatsSection />
      <ResearchTimeline />
      <AboutPreview />
      {faqs.length > 0 && <FAQPreview faqs={faqs} />}
      <Newsletter />
    </div>
  );
}
